module.exports = __webpack_public_path__ + "img/ameba.e49c480f.jpg";